export default {"src":"/_next/static/media/devops-auto.dceec48c.svg","height":48,"width":48,"blurWidth":0,"blurHeight":0};